import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { generalPostFunction } from "../Globals/globalFunctions";
import { cardArray, gameCollectionArray, gamePorts } from "../Globals/globalMetaData";
import { SvgIcon } from "../Components/SvgIcons";

function ResultHistory() {
	const navigate = useNavigate();
	const [gameName, setGameName] = useState("spin2win");
	const [gameResult, setGameResult] = useState([]);
	const [dateSelect, setDateSelect] = useState(new Date().toISOString().split("T")[0]);

	const getResultByDate = async () => {
		try {
			const selectedGame = gameName;
			const port = gamePorts[selectedGame] || "3001";

			const payload = {
				date: dateSelect,
			};
			const response = await generalPostFunction("/history", payload, port);
			if (response.length > 0) {
				setGameResult(response);
			}
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		getResultByDate();
	}, [gameName]);

	return (
		<>
			<div className="overviewTableWrapper">
				<div className="overviewTableChild">
					<div className="d-flex flex-wrap">
						<div className="col-12">
							<div className="heading">
								<div className="content">
									<h4>Result History </h4>
								</div>
								<div className="buttonGroup">
									<button className="panelButton gray" onClick={() => navigate(-1)}>
										<span className="text">Back</span>
										<span className="icon">
											<SvgIcon name="back" />
										</span>
									</button>
								</div>
							</div>
						</div>
						<div className="col-12" style={{ overflow: "auto", padding: "10px 20px 0px" }}>
							<div className="tableHeader">
								<div className="d-flex justify-content-xl-end">
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Game Name</label>
										<select className="formItem" defaultValue={"spin2win"} onChange={(e) => setGameName(e.target.value)}>
											{gameCollectionArray.map((item, index) => (
												<option key={index} value={item.value}>
													{item.label}
												</option>
											))}
										</select>
									</div>
									<div className="formRow border-0">
										<label className="formLabel text-start mb-0 w-100">Date</label>
										<div className="d-flex w-100">
											<input type="date" className="formItem" value={dateSelect} onChange={(e) => setDateSelect(new Date(e.target.value).toISOString().split("T")[0])} />
										</div>
									</div>
									<button type="button" className="panelButton mt-auto mb-2" onClick={getResultByDate}>
										<span className="text">Search</span>
										<span className="icon">
											<SvgIcon name="search" />
										</span>
									</button>
								</div>
							</div>
							<div className="tableContainer">
								<table>
									<thead>
										<tr>
											<th style={{ width: "20px" }}>#</th>
											<th>DATE</th>
											<th>TIME</th>
											<th>RESULT</th>
											<th>BONUS</th>
											<th>Game Id</th>
										</tr>
									</thead>
									<tbody>
										{gameResult && gameResult.length > 0 ? (
											gameResult
												.sort((a, b) => b.id - a.id)
												.map((item, index) => {
													const date = new Date(item.result_date);
													const time = new Date(item.created_at);
													const formattedDate = date.toLocaleDateString("en-US", {
														month: "short",
														day: "numeric",
														year: "numeric",
													});
													const formattedTime = time.toLocaleTimeString("en-US", {
														hour: "numeric",
														minute: "2-digit",
														hour12: true,
													});
													const result = cardArray.find((card) => card.nCardId == item.result);
													return (
														<tr>
															<td style={{ width: "20px" }}>{index + 1}</td>
															<td>{formattedDate}</td>
															<td>{item.result_time}</td>
															<td>
																{gameName == "spin2win" || gameName == "triplechance" ? (
																	<label>{item.result.substring(1)}</label>
																) : (
																	<div className="resultBlock">
																		<label className="fw-bold">{result.name.substring(0, 1)}</label>
																		<img className="ms-1" src={`/assets/images/report/${result.name.substring(1)}.png`} style={{ width: "15px" }} />
																	</div>
																)}
															</td>
															<td>{item.multiplier == 1 ? "-" : `${item.multiplier}X`}</td>
															<td>{item.id}</td>
														</tr>
													);
												})
										) : (
											<tr>
												<td colSpan={99} className="text-center">
													No Data Found
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default ResultHistory;
